import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';

export type Intersection =
  | {
      isIntersect: true;
      collision: {
        direction: 'east' | 'west';
        interfall: BelegungsIntervall;
      };
    }
  | {
      isIntersect: false;
    };

export function isMouseIntersectInterval(
  intervall: BelegungsIntervall[],
  position: { x: number; y: number },
  start: { x: number; y: number },
): Intersection {
  for (let index = 0; index < intervall.length; index++) {
    const element = intervall[index];

    if (start.x <= element.startX && position.x >= element.startX) {
      return {
        isIntersect: true,
        collision: {
          direction: 'east',
          interfall: element,
        },
      };
    }

    if (
      start.x >= element.startX + element.width &&
      position.x <= element.startX + element.width
    ) {
      return {
        isIntersect: true,
        collision: {
          direction: 'west',
          interfall: element,
        },
      };
    }
  }
  return {
    isIntersect: false,
  };
}
